import { Component, Input, Output, EventEmitter, OnInit, TemplateRef, ViewChild, ChangeDetectorRef, OnChanges, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { UtilityService } from '../../../common/services/utility.service';
import { Material } from '../../../order/resources/material';
import { Product, ProductRepairPlan } from '../../../order/resources/product';
import { PurchasedItem } from '../../../order/resources/purchased-item';
import { OutsideProcessSpecification, Station } from '../../../order/resources/station';
import { Workflow, WorkflowStep, WorkflowStepInventoryItem, WorkflowStepInventoryItemType, WorkflowStepType } from '../../../order/resources/workflow';
import { OrderService } from '../../../order/services/order.service';
import { StationService } from '../../../order/services/station.service';
import { Department } from '../../../floor/resources/building';
import { MachineAssignment } from '../../../planning/resources/machine-assignment';
import { OrderProduct, OrderStatus } from '../../../order/resources/order';
import { WorkOrder } from '../../../planning/resources/work-order';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { PlanningService } from '../../services/planning.service';
import { BehaviorSubject, combineLatest, Observable, ReplaySubject, Subject } from 'rxjs';
import { filter, map, shareReplay, switchMap } from 'rxjs/operators';
import { PlanningDetailService } from '../planning-detail.service';
import { MaterialBid } from '../../../purchasing/resources/materialBid';
import { CreateChange, DeleteChange, SortWorkflowStepChange, UpdateChange } from '../../../common/autosaving/change';
import { MatMenuTrigger } from '@angular/material/menu';
import { MatSidenav } from '@angular/material/sidenav';
import { fetchLatest } from '@cots/order/components/order-detail-new/order-detail.service';

@Component({
  selector: 'workflow-step-items',
  templateUrl: './workflow-step-items.component.html',
  styleUrls: ['./workflow-step-items.component.less']
})
export class WorkflowStepItemsComponent implements OnInit, OnChanges {

  @Input() product: Product;
  @Input() editing: boolean;
  @Input() workOrder: WorkOrder = null;
  @Input() machineAssignments: MachineAssignment[] = null;
  @Output() machineAssignmentsChange: EventEmitter<MachineAssignment[]> = new EventEmitter<MachineAssignment[]>();
  @Output() workOrderEdit: EventEmitter<Product> = new EventEmitter<Product>();
  @Output() productChange = new EventEmitter<Product>();
  public dirty = false;
  @Input() childProducts: Product[];
  private stationList: Station[] = null;
  public loading = false;
  public selectedStep: WorkflowStep = null;
  public allProducts: Product[] = [];
  public reordering = false;
  @ViewChild('newStepDialogTemplate', { static: true }) newStepDialogTemplate: TemplateRef<any>;

  constructor(
    private detailService: PlanningDetailService,
    private planningService: PlanningService,
    private stationService: StationService,
    private orderService: OrderService,
    private utilityService: UtilityService,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef,
  ) { }

  // private sortWorkflow(): void {
  //   this.steps = this.steps.sort((a, b) => { return a.stepOrder - b.stepOrder; });
  //   if (this.repairPlan) this.repairPlan.workflow.workflowSteps = this.repairPlan.workflow.workflowSteps.sort((a, b) => { return a.stepOrder - b.stepOrder; });
  // }

  public getAssignment(step: WorkflowStep): MachineAssignment {
    if (step == null) return null;

    return this.machineAssignments.find(a => a != null && a.workflowStepId == step.workflowStepId);
  }

  public saveAssignment(step: WorkflowStep, dept: Department): void {
    if (dept == null || step == null)
      return;

    var assignment = this.getAssignment(step);

    if (assignment == null) {
      assignment = <MachineAssignment>{
        assignmentId: UtilityService.emptyGuid,
        department: dept,
        departmentId: dept.departmentId,
        operation: step,
        workflowStepId: step.workflowStepId,
        workOrder: this.workOrder,
        workOrderId: this.workOrder.workOrderId,
        machine: null,
        machineId: null,
        status: OrderStatus.UNASSIGNED,
        requestedQty: this.product.orderQuantity
      };
      this.dirty = true;
      this.machineAssignments.push(assignment);
    }
    else {
      if (assignment.departmentId !== dept.departmentId) this.dirty = true;
      assignment.departmentId = dept.departmentId;
      assignment.department = dept;
    }

    this.machineAssignmentsChange.emit(this.machineAssignments);

  }

  public getInputItems(step: WorkflowStep): WorkflowStepInventoryItem[] {
    return step.workflowStepInventoryItems.filter(item => item.type === WorkflowStepInventoryItemType.INPUT || item.type === WorkflowStepInventoryItemType.TOOLING).sort((a, b) => (a.type - b.type));
  }

  public getOutputItems(step: WorkflowStep): WorkflowStepInventoryItem[] {
    return step.workflowStepInventoryItems.filter(item => item.type === WorkflowStepInventoryItemType.OUTPUT);
  }

  public getInspectionToolingItems(step: WorkflowStep): WorkflowStepInventoryItem[] {
    return step.workflowStepInventoryItems.filter(item => item.type === WorkflowStepInventoryItemType.INSPECTION_TOOLING).sort((a, b) => (a.type - b.type));
  }

  public get stepInputItems(): WorkflowStepInventoryItem[] {
    if (!this.selectedStep) return [];
    return this.getInputItems(this.selectedStep);
  };

  public get stepOutputItems(): WorkflowStepInventoryItem[] {
    if (!this.selectedStep) return [];
    return this.getOutputItems(this.selectedStep);
  }

  public get stepInspectionToolingItems(): WorkflowStepInventoryItem[] {
    if (!this.selectedStep) return [];
    return this.getInspectionToolingItems(this.selectedStep);
  }

  public getStation(item: WorkflowStep): Station {
    if (this.stationList == null || item == null || item.stationId == null)
      return null;

    return this.stationList.find(r => r.stationId == item.stationId);
  }

  public async addItem(direction: 'INPUT' | 'OUTPUT' | 'INSPECTION_TOOLING') {
    const ref = this.dialog.open(this.newStepDialogTemplate, {
      minWidth: 500,
      data: {
        direction,
        type: direction === 'INSPECTION_TOOLING' ? 'TOOLING' : 'PURCHASED',
        product: null,
        material: null,
        purchasedItem: null,
        quantity: 1,
        isTooling: false,
      }
    });
    const result: {
      type: 'PURCHASED' | 'PRODUCT' | 'MATERIAL' | 'TOOLING',
      product: Product,
      material: Material,
      purchasedItem: PurchasedItem,
      quantity: number,
    } = await ref.afterClosed().toPromise();
    if (!result) return;

    const isTooling = result.type === 'TOOLING';

    const data = {
      product: null,
      material: null,
      purchasedItem: null,
      quantity: result.quantity,
      type: direction === 'INSPECTION_TOOLING' ? WorkflowStepInventoryItemType.INSPECTION_TOOLING :
      (isTooling ? WorkflowStepInventoryItemType.TOOLING : (direction === 'INPUT' ? WorkflowStepInventoryItemType.INPUT : WorkflowStepInventoryItemType.OUTPUT)),
    };

    if (result.type === 'PRODUCT') {
      data.product = result.product;
    } else if (result.type === 'MATERIAL') {
      data.material = result.material;
    } else if (result.type === 'PURCHASED' || result.type === 'TOOLING') {
      data.purchasedItem = result.purchasedItem;
    }

    this.loading = true;
    await this.orderService.addWorkflowStepItem(this.selectedStep, data).toPromise();
    const step = await this.orderService.getWorkflowStep(this.selectedStep.workflowStepId).toPromise();
    console.log(step.workflowStepInventoryItems)
    this.selectedStep.workflowStepInventoryItems = step.workflowStepInventoryItems
    this.loading = false;
    this.dirty = true;
    this.productChange.emit(this.product);
    this.markForProcessing();

  }

  public async deleteItem(item: WorkflowStepInventoryItem) {
    const r = await this.utilityService.showConfirmationPromise(`Are you sure you want to delete this item?`, 'This cannot be undone.');
    if (!r) return;
    this.loading = true;
    await this.orderService.deleteWorkflowStepItem(item).toPromise();
    const step = await this.orderService.getWorkflowStep(this.selectedStep.workflowStepId).toPromise();
    console.log(step.workflowStepInventoryItems)
    this.selectedStep.workflowStepInventoryItems = step.workflowStepInventoryItems
    this.loading = false;
    this.dirty = true;
    this.productChange.emit(this.product);
    this.markForProcessing();
  }

  private getProductChildren(product: Product): Promise<void> {
    return new Promise<void>(async (resolve) => {
      const children = await this.orderService.getChildProducts(product.productId).toPromise()
      product.childAssemblies = children
      if (children.length === 0) {
        resolve()
      } else {
        await Promise.all(product.childAssemblies.map(child => this.getProductChildren(child)))
        resolve()
      }
    })
  }

  public isInteger = Number.isInteger;

  public stations$: Observable<Station[]>;
  ngOnInit() {
    if (this.stationService.loaded) {
      this.stationList = this.stationService.stationList;
    }
    else {
      this.stationService.stationsLoaded.subscribe(
        _ => this.stationList = this.stationService.stationList
      );
    }
    this.stations$ = this.stationService.stations.pipe(map(sl => sl.filter(s => !s.isDeleted)));
    this.setupProductData();
  }
  
  public getStatusText(disposition: number): string {
    return OrderStatus.getStatusText(disposition);
  }

  public getStatusColorClass(status: number): string {
    return OrderStatus.getStatusColorClass(status);
  }

  @Output() programTab = new EventEmitter<void>();
  public goToProgramming() {
    this.programTab.emit();
  }

  public startSorting() {
/*     this.oldOrder = this.steps.reduce((acc, x) => {
      acc[x.workflowStepId] = x.stepOrder;
      return acc;
    }, {}) */;
    this.reordering = true;
    this.dirty = true;
  }

  public cancelSorting() {
    this.reordering = false;
  }

  public doSort(product: Product, event: CdkDragDrop<WorkflowStep[]>) {
    if (event.previousIndex === event.currentIndex) return;
    const change: SortWorkflowStepChange = {
      changeType: 'SORT_WORKFLOW_STEP',
      entity: null,
      data: {
        productId: product.productId,
        oldIndex: event.previousIndex,
        newIndex: event.currentIndex,
      },
    };
    this.detailService.autosaver.recordChanges(change);
  }

  public getStatusIcon(status: number) {
    if (status == 0) return 'more_horiz';
    if (status == 1) return 'error';
    if (status == 2) return 'check';
  }

  public getStepStatusText(status: number) {
    if (status == 0) return 'Not Planned';
    if (status == 1) return 'Needs Check';
    if (status == 2) return 'Planned';
  }

  public async onStatusChange(step: WorkflowStep, status: number) {
    const change: UpdateChange = {
      changeType: 'UPDATE',
      entity: 'WorkflowStep',
      data: {
        field: 'planningStatus',
        itemId: step.workflowStepId,
        oldValue: step.planningStatus,
        newValue: status,
      },
    };
    this.detailService.autosaver.recordChanges(change); 
  }

  @ViewChild('sidenav') sidenav: MatSidenav;
  public startAddingStep() {
    this.sidenav.open();
  }


  public get isRepair(): boolean {
    return !!this.product.productRepairPlan;
  }
  
  public async finishAddingStep(product: Product, station: Station) {
    const newStep = WorkflowStep.newEmptyStep(station);
    newStep.workflowStepId = UtilityService.newGuid();
    newStep.workflowId = product.workflowWorkflowId;
    const change: CreateChange = {
             changeType: 'CREATE',
      entity: 'WorkflowStep',
      data: {
        itemId: newStep.workflowStepId,
        value: newStep
      },
    };
    this.detailService.autosaver.recordChanges(change); 
    this.sidenav.close();
  }

  public async deleteStep(step: WorkflowStep) {
    const r = await this.utilityService.showConfirmationPromise('Are you sure?', 'Really delete this step? This cannot be undone.');
    if (!r) return;
    const stepId = step.workflowStepId;
    const change: DeleteChange = {
             changeType: 'DELETE',
      entity: 'WorkflowStep',
      data: {
        itemId: stepId,
        oldValue: step,
      },
    };
    this.detailService.autosaver.recordChanges(change); 
  }

  public generateStation(name: string): Partial<Station> {
    // TODO
    return {}
  }
  public getStationName(station: Station) {
    return station?.name;
  }

  public async onNewOPSpec(spec: OutsideProcessSpecification) {
    this.loading = true;
    await this.stationService.createSpec(this.selectedStep.stationId, spec.name, spec.outsideProcessSpecificationId).toPromise();
    this.loading = false;
    this.cdr.detectChanges();
  }

  private switching = false;
  public onStepEdited(step?: WorkflowStep) {
    if (!this.switching) {
      this.dirty = true;
      if (step) {
        const origStep = this.product.workflow.workflowSteps.find(s => s.workflowStepId === step.workflowStepId);
        Object.assign(origStep, step);
      }
      this.productChange.emit(this.product);
    }
  }

  private selectedStepId$ = new BehaviorSubject<string>(null);
  public selectStep(step: WorkflowStep) {
    this.switching = true;
    this.selectedStepId$.next(step.workflowStepId);
    this.selectedStep = step;
    setTimeout(() => this.switching = false);
  }

  onOpQuote(step: WorkflowStep, quote: MaterialBid) {
    this.onStepEdited(step);
    this.detailService.addQuotes(quote.stationId, [quote]);
  }
  
  public onStepFieldChange(stepId: string, { field, oldValue, newValue }: { field: string, oldValue: any, newValue: any }) {
    const change: UpdateChange = {
             changeType: 'UPDATE',
      entity: 'WorkflowStep',
      data: {
        field,
        itemId: stepId,
        oldValue,
        newValue
      }
    };
    this.detailService.autosaver.recordChanges(change);
    this.productChange.emit(this.product);
  }

  public markForProcessing() {
    this.planningService.markForWOProcessing(this.detailService.planningTicketId).subscribe(() => {});
  }
  
  @ViewChild(MatMenuTrigger) menuTrigger: MatMenuTrigger;
  public menuPosition: { x: number; y: number } = { x: 0, y: 0 }
  public menuItem: WorkflowStep | null = null;
  public openMenu(event: MouseEvent, item: WorkflowStep) {
    if (!item) {
      return
    }
    this.menuPosition = {
      x: event.clientX ?? 0,
      y: event.clientY ?? 0
    }
    if (!this.menuItem) return;
    event.preventDefault();
    this.menuTrigger.openMenu();
  }

  private productId = new ReplaySubject<string>(1);
  public productData$: Observable<Product>;
  public selectedStep$: Observable<WorkflowStep>;

  private setupProductData() {
    this.productData$ = this.productId.pipe(
      switchMap(id => this.detailService.autosaver.getPostChanges('productsMap').pipe(
          map((prods) => prods[id]),
        )),
      shareReplay(1)
    );
    this.selectedStep$ = combineLatest([this.productData$, this.selectedStepId$]).pipe(
      map(([prod, stepId]) => prod?.workflow?.workflowSteps?.find(s => s.workflowStepId === stepId)),
      filter(s => !!s),
      shareReplay(1)
    )
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.product?.currentValue?.productId) {
      this.productId.next(changes.product.currentValue.productId);
    }  
  }
}
